import { useState } from "react";
import api from "@/api/client";
import { Download } from "lucide-react";

async function downloadBlob(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = href; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
}

export default function AdminExports() {
  const [loading, setLoading] = useState("");

  const handle = async (key, url, filename) => {
    setLoading(key);
    try { await downloadBlob(url, filename); } finally { setLoading(""); }
  };

  const items = [
    { key: "csv", label: "Participantes (CSV UTF-8)", desc: "RUT, nombre, correo, unidad, cargo, estado.", url: "/admin/export/participants.csv", filename: "participantes_anid.csv" },
    { key: "xlsx", label: "Exportación completa (Excel, hojas separadas)", desc: "Participantes, respuestas de diagnóstico, puntajes calculados, actividades, asistencia y rúbricas/revisiones.", url: "/admin/export/full.xlsx", filename: "ANID_INSIDE_export_completo.xlsx" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-black text-slate-800">Exportaciones</h1>
        <p className="text-sm text-slate-500">Archivos protegidos contra inyección de fórmulas, con identificadores y fechas para trazabilidad.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((it) => (
          <div key={it.key} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
            <h3 className="text-sm font-black text-slate-800 mb-1">{it.label}</h3>
            <p className="text-xs text-slate-500 mb-4">{it.desc}</p>
            <button data-testid={`export-${it.key}-btn`} disabled={loading === it.key} onClick={() => handle(it.key, it.url, it.filename)} className="flex items-center gap-2 px-5 py-2.5 bg-brand-slate hover:bg-slate-900 text-white text-xs font-bold rounded-xl disabled:opacity-60">
              <Download className="w-4 h-4" /> {loading === it.key ? "Generando..." : "Descargar"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
